import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress, Typography, IconButton, InputBase, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import HelpIcon from '@material-ui/icons/Help';
import React, { useEffect } from "react";
import { useHelp } from "../../utils/HelpContext";
import Tooltip from "../tooltip/Tooltip";
import DeleteIcon from '@material-ui/icons/Delete';
// import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { recordProjectVisit } from "../../utils/projectVisit";
import { useSelector } from "react-redux";
import { ProjectState } from "../../app/reducer/project.reducer";
// import Tooltip from '@material-ui/core/Tooltip';

interface SearchListProps {
  btnVariant: "primary" | "secondary";
  searchLabel: string;
  colHeaders: any[];
  rowKeys: any[];
  data?: any[];
  busy?: boolean;
  cta?: Function;
  ctaRemove?: Function;
  nobar?: boolean;
}
interface IRootState {
  project: ProjectState;
  auth: any;
  history: any;
}


export default function SearchList({
  btnVariant,
  colHeaders,
  rowKeys,
  data,
  busy,
  searchLabel,
  cta,
  ctaRemove,
  nobar,
}: SearchListProps): JSX.Element {
  const [searchString, setSearchString] = React.useState<string>('');
  const [dataState, setDataState] = React.useState<any[]>([]);
  const { help } = useHelp(); // Access the help toggle state
    const auth = useSelector((state: IRootState) => state.auth);
  const [activeTooltip, setActiveTooltip] = React.useState<string | null>(null); // Track which tooltip is active

  // Define a type for helpData keys
  type HelpDataKeys = 'Drafts' | 'Projects';
  
  // Define helpData with the possible keys
  const helpData: Record<HelpDataKeys, string> = {
    Drafts: "This is a saved project that is intended to be used later in the project",
    Projects: "List of all the projects running currently",
  };

  // Handle tooltip visibility when clicking the "?" button
  const handleTooltipClick = (fieldId: string) => {
    console.log("Clicked field:", fieldId); // Debugging: check which field is clicked
    setActiveTooltip((prev) => (prev === fieldId ? null : fieldId)); // Toggle tooltip visibility
  };

  // Process the search filter
  useEffect(() => {
    let tempData: any[] = [];
    if (data) {
      tempData = data;
      console.log(data)
      if (searchString) {
        let filteredArr: any[] = [];
        tempData.forEach((item) => {
          rowKeys.forEach((key) => {
            if (key.includes(".")) {
              const keyArr = key.split(".");
              if (item[keyArr[0]]?.[keyArr[1]]?.toString().toLowerCase().includes(searchString.toLowerCase())) {
                filteredArr.push(item);
              }
            } else {
              if (item[key]?.toString().toLowerCase().includes(searchString.toLowerCase())) {
                filteredArr.push(item);
              }
            }
          });
        });
        setDataState(filteredArr);
      } else {
        if((auth.user.userType==4 ||auth.user.userType==3) && !(searchLabel=="Select Fan"))
        tempData=tempData.filter(e=>e.customer_name==auth.user.username)
        console.log(tempData)
        setDataState(tempData);
      }
    }
  }, [data, searchString, rowKeys]);

  return (
    <Paper className="search-list" variant="outlined">
      <Typography variant="h6" gutterBottom>
        <b>&nbsp;{searchLabel}</b>
        {help && (
          <IconButton
            type="button"
            onClick={() => handleTooltipClick(searchLabel)}
            color="primary" // You can customize the color as needed
            // Adjust margin for spacing
            style={{padding:'0px'}}
          >
            <HelpIcon />
          </IconButton>
        )}
        {/* Ensure the Tooltip receives a string from helpData safely */}
        <Tooltip text={helpData[searchLabel as HelpDataKeys]} isVisible={activeTooltip === searchLabel} />
      </Typography>

      {/* Input Field for Search */}
      {(nobar === undefined) && (
        <Paper component="form" elevation={3} style={{ width: '100%', display: 'flex', padding: '10px' }}>
          <InputBase
            style={{ flex: 1 }}
            placeholder={searchLabel}
            inputProps={{ 'aria-label': searchLabel }}
            onChange={(e) => setSearchString(e.target.value)}
          />
          <IconButton  disabled={busy} aria-label="search" style={{color:'#48bc97', padding: '10px' }}>
            <FontAwesomeIcon icon={faSearch} />
          </IconButton>
        </Paper>
      )}
      <hr />

      {/* Table for Data Display */}
      <TableContainer component={Paper} style={{ width: "100%", flex: 1 }}>
        {busy ? (
          <CircularProgress size={26} />
        ) : (
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                {colHeaders.map((el, i) => {
                  if (el === "ACTION" && !ctaRemove) {
                    return null;
                  }
                  return <TableCell key={i}><b style={{fontSize:'18px'}}>{el}</b></TableCell>;
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {dataState && dataState.length > 0
                ? dataState.filter(item => item != null).map((fan, i) => (
                  <TableRow key={i} style={{ height: '100px' }}>
                    {rowKeys.map((el, i) => {
                      let key = el as string;
                      console.log(key)
                      if (key.includes(".")) {
                        let keyArr = el.split(".");
                        return (
                          <TableCell style={{fontSize:'18px'}}  key={"cell" + i} component="th" scope="row">
                            &nbsp;{fan[keyArr[0]]?.[keyArr[1]]?.toFixed(2)}
                          </TableCell>
                        );
                      } else {
                        let item = fan[el];
                        console.log(item,el)
                        if (el === 'userType') {
                          item = fan[el] === 1 ? 'Admin' :fan[el] === 2 ? 'User':fan[el] === 3? 'Agent' :'Customer';
                        } else if (el === 'isActive') {
                          item = fan[el] === true ? 'Active' : 'In-Active';
                        }
                        return (
                          <TableCell style={{fontSize:'18px'}} key={"cell" + i} component="th" scope="row">
                            &nbsp;{el==='createdAt'?new Date(item).toLocaleDateString('en-US') :item}
                          </TableCell>
                        );
                      }
                    })}
                    {cta && (
                      <TableCell key={"cell" + i} component="th" scope="row">
                        <IconButton
                        onClick={() =>{ recordProjectVisit(fan); cta(fan)}}
                        style={{
                          backgroundColor: '#e6f4ef',
                          color: '#10B981',
                        }}
                      >
                        <VisibilityIcon />
                      </IconButton>
                      </TableCell>
                    )}
                    {ctaRemove && (
                      <TableCell key={"cell" + i} component="th" scope="row">
                      <IconButton
                        onClick={() => {
                          const confirmDelete = window.confirm(`Are you sure you want to delete`);
                          if (confirmDelete) {
                            ctaRemove(fan);
                          } 
                          setDataState(prev => prev.filter(u => u.email !== fan.email));
                          setDataState(prev => prev.filter(u => u._id !== fan._id));
                        }}
                        style={{
                          color: '#EF4444',
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                      </TableCell>
                    )}
                  </TableRow>
                ))
                : null
              }
            </TableBody>
          </Table>
        )}
        {(!dataState || dataState.length === 0) && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80%' }}>
            No Data
          </div>
        )}
      </TableContainer>
    </Paper>
  );
}
